import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';

import { functions } from '../functions/_functions';

import Div from './Div';
import Button from './Button';

const duration = 300;

/**
 * Default Style for SlideshowContent
 */
const defaultSlideshowContentStyle = {
  transition: `all ${duration}ms ease-in-out`,
  opacity: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
};

/**
 * Trasition Styles for SlideshowContent
 */
const transitionSlideshowContentStyles = {
  entering: {
    forward: () => ({
      opacity: 0,
      transform: 'translateX(100%)',
      height: '0',
    }),
    backward: () => ({
      opacity: 0,
      transform: 'translateX(-100%)',
      height: '0',
    }),
  },
  entered: {
    forward: (contentMinHeight) => ({
      opacity: 1,
      transform: 'translateX(0%)',
      height: 'auto',
      minHeight: contentMinHeight,
    }),
    backward: (contentMinHeight) => ({
      opacity: 1,
      transform: 'translateX(0%)',
      height: 'auto',
      minHeight: contentMinHeight,
    }),
  },
  exiting: {
    forward: (contentMinHeight) => ({
      opacity: 1,
      transform: 'translateX(0%)',
      height: 'auto',
      minHeight: contentMinHeight,
    }),
    backward: (contentMinHeight) => ({
      opacity: 1,
      transform: 'translateX(0%)',
      height: 'auto',
      minHeight: contentMinHeight,
    }),
  },
  exited: {
    forward: () => ({
      opacity: 0,
      transform: 'translateX(100%)',
      height: '0',
    }),
    backward: () => ({
      opacity: 0,
      transform: 'translateX(-100%)',
      height: '0',
    }),
  },
};

class SimpleSlideshow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slideIndex: 0,
      direction: 'forward',
    };
  }

  render() {
    const {
      slides,
      containerStyle,
      containerStyleOverride,
      navStyle,
      navStyleOverride,
      navButtonStyle,
      navButtonStyleOverride,
      contentStyle,
      contentStyleOverride,
      contentMinHeight,
      firstSlideButtonText,
      lastSlideButtonText,
      forwardButtonText,
      backwardButtonText,
      onComplete,
    } = this.props;
    const { direction, slideIndex } = this.state;
    return (
      <Div
        onClick={(e) => {
          e.stopPropagation();
        }}
        {...containerStyle}
        {...containerStyleOverride}
      >
        {functions.range(0, slides.length - 1, 1).map((value) => (
          <Transition in={slideIndex === value} timeout={duration}>
            {(innerTransitionState) => (
              <Div
                style={{
                  ...defaultSlideshowContentStyle,
                  ...transitionSlideshowContentStyles[innerTransitionState][direction](contentMinHeight), // eslint-disable-line max-len
                }}
                {...contentStyle}
                {...contentStyleOverride}
              >
                {slides[value]}
              </Div>
            )}
          </Transition>
        ))}
        <Div {...navStyle} {...navStyleOverride}>
          {slideIndex > 0 ? (
            <Button
              onClick={() => {
                if (slideIndex > 0) {
                  this.setState((prevState) => ({
                    slideIndex: (prevState.slideIndex - 1) % slides.length,
                    direction: 'backward',
                  }));
                }
              }}
              {...navButtonStyle}
              {...navButtonStyleOverride}
            >
              {backwardButtonText}
            </Button>
          ) : null}
          {slideIndex < slides.length ? (
            <Button
              onClick={() => {
                if (slideIndex === slides.length - 1) {
                  onComplete();
                } else {
                  this.setState((prevState) => ({
                    slideIndex: (prevState.slideIndex + 1) % slides.length,
                    direction: 'forward',
                  }));
                }
              }}
              {...navButtonStyle}
              {...navButtonStyleOverride}
            >
              {slideIndex === 0
                ? firstSlideButtonText
                : slideIndex === slides.length - 1
                  ? lastSlideButtonText
                  : forwardButtonText}
            </Button>
          ) : null}
        </Div>
      </Div>
    );
  }
}

SimpleSlideshow.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.node),
  containerStyle: PropTypes.shape({}),
  containerStyleOverride: PropTypes.shape({}),
  navStyle: PropTypes.shape({}),
  navButtonStyle: PropTypes.shape({}),
  contentStyle: PropTypes.shape({}),
  navStyleOverride: PropTypes.shape({}),
  navButtonStyleOverride: PropTypes.shape({}),
  contentStyleOverride: PropTypes.shape({}),
  contentMinHeight: PropTypes.string,
  forwardButtonText: PropTypes.string,
  backwardButtonText: PropTypes.string,
  firstSlideButtonText: PropTypes.string,
  lastSlideButtonText: PropTypes.string,
  onComplete: PropTypes.func,
};

SimpleSlideshow.defaultProps = {
  slides: [],
  containerStyle: {
    bg: 'shopify',
    d: 'flex',
    w: '100%',
    flexDir: 'column',
    justify: { xs: 'start', md: 'center' },
    align: 'center',
  },
  containerStyleOverride: {},
  navStyle: {
    m: { t: '32px', b: '32px' },
    d: 'flex',
    flexDir: { xs: 'column', md: 'row' },
    justify: 'center',
  },
  navStyleOverride: {},
  navButtonStyle: {
    m: { x: '16px', y: '8px' },
    w: '160px',
    cursor: 'pointer',
  },
  navButtonStyleOverride: {},
  contentStyle: {
    top: '32px',
    d: 'flex',
    w: '100%',
    align: 'center',
    justify: 'center',
  },
  contentStyleOverride: {},
  contentMinHeight: '1024px',
  forwardButtonText: 'Next',
  backwardButtonText: 'Back',
  firstSlideButtonText: 'Next',
  lastSlideButtonText: 'Finish',
  onComplete: () => null,
};

export default SimpleSlideshow;
